import { render, staticRenderFns } from "./totalinstock-history.vue?vue&type=template&id=58fb35a8&"
import script from "./totalinstock-history.vue?vue&type=script&lang=ts&"
export * from "./totalinstock-history.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports